var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid h-100"},[_c('div',{staticClass:"jumbotron center"},[_c('h1',{staticClass:"display-4"},[_vm._v("QCFS Missy")]),_c('p',{staticClass:"lead"},[_vm._v(" Report any issues to "),_c('a',{attrs:{"href":"mailto:it@qcfreightservice.com"}},[_vm._v("QCFS IT")])])])])
}]

export { render, staticRenderFns }